import { render, staticRenderFns } from "./userset_msg.vue?vue&type=template&id=b3959bae"
import script from "./userset_msg.vue?vue&type=script&lang=js"
export * from "./userset_msg.vue?vue&type=script&lang=js"
import style0 from "./userset_msg.vue?vue&type=style&index=0&id=b3959bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports